import { Row, Col, Card, Button, InputGroup, Form } from "react-bootstrap";
import { SchoolString, String } from "../../../utils/string";
import clsx from "clsx";
import { CustomSelectWhite } from "../../custom/Select/CustomSelectWhite";
import { FC, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import APICallService from "../../../api/apiCallService";
import { academic, MASTER, SCHOOL } from "../../../api/apiEndPoints";
import { schoolJSON } from "../../../api/apiJSON/school";
import { success } from "../../../Global/toast";
import { SchoolToast } from "../../../utils/toast";
import { fileValidation } from "../../../Global/fileValidation";
import CrossIcon from "../../../_uLearn/assets/media/close.png";
import uploadIcon from "../../../_uLearn/assets/media/svg_uLearn/upload.svg";
import imageUpload from "../../../_uLearn/assets/media/preloader.gif";
import { useAuth } from "../auth";
import Loader from "../../../Global/loader";
import Validations from "../../../utils/validations";
import AWS from "aws-sdk";
import Resizer from "react-image-file-resizer";
import Spinner from "react-bootstrap/Spinner";
import Method from "../../../utils/methods";
import {
  Region,
  S3_BUCKET_NAME,
  accessKey,
  monthNames,
  secretKey,
} from "../../../utils/constants";
const S3_BUCKET = S3_BUCKET_NAME;
const REGION = Region;
AWS.config.update({
  accessKeyId: accessKey,
  secretAccessKey: secretKey,
  region: REGION,
});
const s3 = new AWS.S3();
const EditSchool: FC = () => {
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [fetchLoader, setFetchLoader] = useState(true);
  const [ImageLoading, setImageLoading] = useState(false);
  const [classDetails, setClassDetails] = useState([]);
  const [academicDetails, setAcademicDetails] = useState([]);
  const [schoolData, setSchoolData] = useState<{
    name: string;
    phoneCountry: string;
    address: string;
    adminName: string;
    classDetails: any;
    academicYear: any;
    academicSession: any;
    city: string;
    state: any;
    postalCode: string;
    country: string;
    phone: string;
    email: string;
    image: any;
    imageReader: any;
    lat: string;
    lng: string;
    thumbnail: any;
  }>({
    name: "",
    phoneCountry: "+255",
    address: "",
    adminName: "",
    classDetails: [],
    academicYear: [],
    academicSession: [],
    city: "",
    state: "",
    postalCode: "",
    country: "",
    phone: "",
    email: "",
    image: "",
    imageReader: {},
    lat: "0.0",
    lng: "0.0",
    thumbnail: "",
  });
  const [schoolValidation, setSchoolValidation] = useState<{
    name: boolean;
    adminName: boolean;
    phone: boolean;
    address: boolean;
    city: boolean;
    state: boolean;
    postalCode: boolean;
    email: boolean;
    country: boolean;
    classDetails: boolean;
    academicYear: boolean;
    academicSession: boolean;
    image: boolean;
  }>({
    name: false,
    adminName: false,
    phone: false,
    address: false,
    city: false,
    state: false,
    postalCode: false,
    email: false,
    country: false,
    classDetails: false,
    academicYear: false,
    academicSession: false,
    image: false,
  });
  const nameRef: any = useRef(null);
  const phoneNumberRef = useRef(null);
  const adminNameRef = useRef(null);
  const emailRef = useRef(null);
  const classRef = useRef(null);
  const imageRef = useRef(null);
  useEffect(() => {
    if (!state?._id) {
      return window.history.back();
    }
    (async () => {
      setFetchLoader(true);
      await fetchClassDetails();
      await fetchSchoolDetails(state?._id);
      await fetchAcademicList(1, 10);
      setFetchLoader(false);
    })();
  }, []);
  const fetchClassDetails = async () => {
    setFetchLoader(true);
    let apiService = new APICallService(MASTER.CLASS_SUBJECT_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setClassDetails(response.records);
    }
    setFetchLoader(false);
  };
  const fetchSchoolDetails = async (id: string) => {
    setFetchLoader(true);
    let apiService = new APICallService(SCHOOL.GET_SCHOOL_INFO, id);
    let response: any = await apiService.callAPI();
    if (response) {
      const temp: any = { ...response };
      temp.adminName = response.user.name;
      temp.email = response.user.email;
      temp.classDetails = response.class;
      temp.academicYear = [];
      temp.academicSession = response.academicSession.map((val: any) => ({
        value: val.reference,
        label: `${monthNames[val.startMonth - 1]}${val.startYear} - ${
          monthNames[val.endMonth - 1]
        }${val.endYear}`,
        _id: val.reference,
      }));
      setSchoolData(temp);
    } else {
      setSchoolData({
        name: "",
        phoneCountry: "+255",
        address: "",
        adminName: "",
        classDetails: [],
        academicYear: [],
        academicSession: [],
        city: "",
        state: "",
        postalCode: "",
        country: "",
        phone: "",
        email: "",
        image: "",
        imageReader: {},
        lat: "0.0",
        lng: "0.0",
        thumbnail: "",
      });
    }
    setFetchLoader(false);
  };

  const fetchAcademicList = async (
    pageNo: number,
    limit: number,
    searchTerm: string = ""
  ) => {
    // setIsLoading(true);
    const params = {
      pageNo: pageNo,
      limit: limit,
      needCount: pageNo === 1 ? true : false,
      sortKey: "_createdAt",
      sortOrder: -1,
      isActive: true,
      currentYear: true,
      searchTerm: searchTerm.trim(),
    };
    const apiService = new APICallService(academic.GET_ACADEMIC_LIST, params);
    const response = await apiService.callAPI();
    // console.log(response.records);
    let data: any = [...academicDetails];
    if (response) {
      // setActivitiesConfig(response.records);
      response.records.map((val: any) => {
        data.push({
          value: val._id,
          label:
            monthNames[val.startMonth - 1] +
            val.startYear +
            " - " +
            monthNames[val.endMonth - 1] +
            val.endYear,
          _id: val._id,
        });
      });
      setAcademicDetails(data);
    }
    // setIsLoading(false);
  };
  const handleImgChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFiles = event.target.files;
    let tempValidation: any = { ...schoolValidation };
    let temp: any = { ...schoolData };
    if (!selectedFiles) return;
    // else {
    //   if (fileValidation(selectedFiles?.[0])) {
    //     temp.image = URL.createObjectURL(selectedFiles?.[0]);
    //     temp.imageReader = selectedFiles?.[0];
    //     tempValidation.image = false;
    //   }
    // }
    // setSchoolValidation(tempValidation);
    // setSchoolData(temp);
    const file = selectedFiles[0];
    if (fileValidation(file)) {
      const fileName = Method.generateRandomFileName(file.name);
      // Function to upload a file to S3
      const uploadToS3 = (file: any, key: any) => {
        return new Promise((resolve, reject) => {
          const params = {
            Body: file,
            Bucket: S3_BUCKET,
            Key: key,
          };
          s3.upload(params, (err: any, data: any) => {
            if (err) {
              reject(err);
            } else {
              resolve(data.Location);
            }
          });
        });
      };
      setImageLoading(true);
      try {
        // Upload original image
        const originalImageUrl = await uploadToS3(
          file,
          `school/schoolImage/${fileName}`
        );
        // Resize image to create thumbnail
        Resizer.imageFileResizer(
          file,
          100, // maxWidth
          90, // maxHeight
          "JPEG", // format
          100, // quality
          0, // rotation
          async (thumbnail) => {
            const thumbnailFileName = Method.generateRandomFileName(file.name);
            const thumbnailUrl = await uploadToS3(
              thumbnail,
              `school/schoolThumbnail/${thumbnailFileName}`
            );
            // Update state with image and thumbnail URLs
            // const temp = { ...studentData };
            // const tempValidation = { ...studentValidation };
            setSchoolData((prev: any) => {
              const temp = { ...prev };
              temp.image = originalImageUrl;
              temp.thumbnail = thumbnailUrl;
              temp.imageReader = file;
              return temp;
            });
            tempValidation.image = false;
            // Assuming setState function to update state
            // setStudentData(temp);
            // setStudentValidation(tempValidation);
            setSchoolValidation(tempValidation);
            // setSchoolData(temp);
            setImageLoading(false);
          },
          "file" // output type
        );
      } catch (error) {
        console.error("Error uploading files:", error);
        setImageLoading(false);
      }
    }
  };

  const handleImgDiscard = () => {
    let temp = { ...schoolData };
    let tempValidation: any = { ...schoolValidation };
    temp.image = "";
    temp.imageReader = {};
    tempValidation.image = true;
    setSchoolValidation(tempValidation);
    setSchoolData(temp);
  };
  const handleOnKeyPressLetter = (event: any) => {
    const key = event.key.toLowerCase();
    // Allow only alphabets
    if (!/[a-z ]/i.test(key)) {
      event.preventDefault();
    }
  };
  const handleSchoolName = (value: any) => {
    let temp = { ...schoolData };
    let validateTemp = { ...schoolValidation };
    temp.name = value.trimStart();
    if (value.trimStart().length > 0) {
      validateTemp.name = false;
    } else {
      validateTemp.name = true;
    }
    setSchoolData(temp);
    setSchoolValidation(validateTemp);
  };
  const handleBasicDetailsChange = (name: string, value: string) => {
    let temp: any = { ...schoolData };
    let tempValidation: any = { ...schoolValidation };
    temp[name] = value;
    tempValidation[name] = false;

    if (
      name === "name" ||
      name === "city" ||
      name === "country" ||
      name === "state" ||
      name === "adminName"
    ) {
      if (value !== "" && !Validations.allowOnlyAlphabets(value)) {
        return;
      }
    }
    if (!value.length) tempValidation[name] = true;
    setSchoolData(temp);
    setSchoolValidation(tempValidation);
  };
  const handlePhoneChange = async (name: string, value: string) => {
    let temp: any = { ...schoolData };
    let tempValidation: any = { ...schoolValidation };
    temp[name] = value.trimStart();
    tempValidation[name] = false;
    if (!value.length) tempValidation[name] = true;
    if (!Validations.allowNumberAndFloat(value)) {
      return;
    }
    if (name === "phone") {
      if (value.length > 12) {
        tempValidation[name] = true;
      }
    }
    if (name === "postalCode") {
      let codeTemp = await Validations.validatePincode(value.trim());
      tempValidation[name] = true;
      if (codeTemp) {
        if (value.length > 1) {
          tempValidation[name] = false;
        } else {
          tempValidation[name] = true;
        }
        temp[name] = value.trimStart();
      }
    }
    setSchoolData(temp);
    setSchoolValidation(tempValidation);
  };
  const handleClassDetails = (selectedOptions: any) => {
    let temp: any = { ...schoolData };
    const tempArr = selectedOptions.map((selectedOption: any) => ({
      reference: selectedOption.value,
      name: selectedOption.label,
    }));
    temp.classDetails = tempArr;
    let validateTemp = { ...schoolValidation };
    if (tempArr.length == 0) {
      validateTemp.classDetails = true;
    } else {
      validateTemp.classDetails = false;
    }
    // Assuming that the schoolData structure is like { classDetails: [] }
    setSchoolData((prevData: any) => ({
      ...prevData,
      classDetails: tempArr,
    }));
    setSchoolValidation(validateTemp);
  };
  const handleAcademicDetails = (selectedOptions: any) => {
    let temp: any = { ...schoolData };
    const tempArr = selectedOptions;
    temp.academicYear = tempArr;
    // let validateTemp = { ...schoolValidation };
    // if (tempArr.length == 0) {
    //   validateTemp.academicYear = true;
    // } else {
    //   validateTemp.academicYear = false;
    // }
    // Assuming that the schoolData structure is like { classDetails: [] }
    setSchoolData((prevData: any) => ({
      ...prevData,
      academicYear: tempArr,
    }));
    // setSchoolValidation(validateTemp);
  };
  const handleOnKeyPress = (event: any, value: any) => {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
      return false;
    }
    return true;
  };
  const handleAddSchool = async () => {
    let temp: any = { ...schoolData };
    // console.log({ temp });
    let validateTemp: any = { ...schoolValidation };
    let focusRef: any = null;
    if (temp.name === "") {
      validateTemp.name = true;
      focusRef = focusRef || nameRef;
    }
    if (temp.image === "") {
      validateTemp.image = true;
      focusRef = focusRef || imageRef;
    }
    if (temp.adminName === "") {
      validateTemp.adminName = true;
      focusRef = focusRef || adminNameRef;
    }
    if (
      temp.phone === "" ||
      temp.phone.length < 9 ||
      temp.phone.length > 12 ||
      !Validations.allowOnlyNumbers(temp.phone)
    ) {
      validateTemp.phone = true;
      focusRef = focusRef || phoneNumberRef;
    }
    if (temp.email === "" || !Validations.validateEmail(temp.email)) {
      validateTemp.email = true;
      focusRef = focusRef || emailRef;
    }
    if (temp.address === "") {
      validateTemp.address = true;
    }
    if (temp.city === "") {
      validateTemp.city = true;
    }
    if (temp.country === "") {
      validateTemp.country = true;
    }
    if (temp.state === "") {
      validateTemp.state = true;
    }
    if (
      temp.postalCode === "" ||
      !Validations.allowOnlyNumbers(temp.postalCode)
    ) {
      validateTemp.postalCode = true;
    }
    if (temp.classDetails === "") {
      validateTemp.classDetails = true;
      focusRef = focusRef || classRef;
    }
    // if (temp.academicYear === "") {
    //   validateTemp.academicYear = true;
    // }
    // console.log(schoolData);
    if (Object.values(validateTemp).every((val) => val === false)) {
      setFetchLoader(true);
      let apiService = new APICallService(
        SCHOOL.EDIT_SCHOOL_INFO,
        schoolJSON.editSchool(temp),
        {
          _id: state._id,
        }
      );
      let response = await apiService.callAPI();
      if (response) {
        success(SchoolToast.updateSchool);
        navigate("/all-schools");
      }
      setFetchLoader(false);
    } else {
      // Scroll to the first invalid input field
      if (focusRef) {
        focusRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center", // Adjust this as needed
        });
      }
    }
    setSchoolValidation(validateTemp);
  };
  return (
    <>
      <Row className="mb-6">
        <Col xs={12}>
          <h1 className="fs-22 fw-bolder">{SchoolString.TitleEdit}</h1>
        </Col>
      </Row>
      {fetchLoader ? (
        <>
          <Row>
            <Col className="d-flex flex-column align-items-center">
              <Loader loading={fetchLoader} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col md={4} className="mb-lg-0 mb-8">
              <Card className="border bg-light">
                <Card.Body>
                  <Row>
                    <Col xs={12}>
                      <h5 className="fs-22 fw-bolder mb-6 required">
                        {SchoolString.uploadPhoto}
                      </h5>
                    </Col>
                    {schoolData.image ? (
                      <Col xs={12} className="text-md-center">
                        <div className="border border-r10px bg-white p-1  ">
                          <div className="image-input image-input-outline min-w-xl-260px min-h-xl-150px ">
                            <div
                              className=" image-input-wrapper shadow-none bgi-contain w-100 h-100 bgi-position-center"
                              style={{
                                backgroundImage: `url(${schoolData.image})`,
                                backgroundRepeat: `no-repeat`,
                              }}
                            >
                              {schoolData.image && (
                                <img
                                  width={262}
                                  height={149}
                                  src={schoolData.image}
                                  className="img-fluid mh-150px border-r10px object-fit-contain"
                                  alt=""
                                />
                              )}
                            </div>
                            <label
                              className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px my-4"
                              data-kt-image-input-action="change"
                              title=""
                            >
                              <img
                                src={CrossIcon}
                                alt=""
                                height={33}
                                width={33}
                                onClick={handleImgDiscard}
                              />
                              {/* <input
                            type="file"
                            name="avatar"
                            accept=".png, .jpg, .jpeg"
                            // onChange={(event) => {
                            //   handleImgChange(event);
                            // }}
                          />
                          <input
                            type="hidden"
                            name="avatar_remove"
                          /> */}
                            </label>
                          </div>
                        </div>
                      </Col>
                    ) : (
                      <Col xs={12} className="text-md-center">
                        <div
                          className={clsx(
                            "upload-btn-wrapper border rounded",
                            schoolValidation.image ? "border-danger" : ""
                          )}
                        >
                          <div className="symbol symbol-md-235px">
                            <img
                              ref={imageRef}
                              src={ImageLoading ? imageUpload : uploadIcon}
                              className={`img-fluid min-h-200px min-w-200px ${
                                ImageLoading ? "imageLoaderGif" : ""
                              }`}
                              alt=""
                            />
                          </div>
                          <input
                            className="w-100 h-100"
                            type="file"
                            name="myfile"
                            onChange={(event) => {
                              handleImgChange(event);
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col md={8}>
              <Card className="bg-light pt-2 mb-6 mb-xl-9 border">
                <Card.Header className="border-bottom-0">
                  <Card.Title>
                    <h5 className="fs-22 fw-bolder">Basic Details</h5>
                  </Card.Title>
                </Card.Header>
                <Card.Body className="pt-0 pb-5">
                  <Row className="align-items-center">
                    <Col>
                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.schoolName}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.name ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="School name..."
                              name="name"
                              value={schoolData?.name}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "name",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                              ref={nameRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.schoolPhoneNumber}
                            </Form.Label>
                            <InputGroup
                              size="lg"
                              className={clsx(
                                " border-right-0 fs-16 fw-600 text-black px-"
                                // schoolValidation.phone ? 'border-danger' : ''
                              )}
                            >
                              <InputGroup.Text
                                id="inputGroup-sizing-lg"
                                className={clsx(
                                  "bg-white border-right-0 fs-16 fw-600 text-black px-6",
                                  schoolValidation.phone ? "border-danger" : ""
                                )}
                                // className="border-0 fs-16 fw-500 text-dark bg-white pe-0"
                              >
                                {String.CountryCode}
                              </InputGroup.Text>
                              <Form.Control
                                className={clsx(
                                  "form-control-custom border-active-none bg-white border-left-0 ps-0",
                                  schoolValidation.phone ? "border-danger" : ""
                                )}
                                type="text"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                placeholder="Phone number..."
                                name="phone"
                                value={schoolData?.phone}
                                onChange={(event: any) => {
                                  handlePhoneChange(
                                    "phone",
                                    event.target.value
                                  );
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event, "phone");
                                }}
                                ref={phoneNumberRef}
                              />
                            </InputGroup>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.schoolAdminName}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.adminName
                                  ? "border-danger"
                                  : ""
                              )}
                              type="text"
                              placeholder="Admin name..."
                              name="name"
                              value={schoolData?.adminName}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "adminName",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                              ref={adminNameRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.schoolAdminEmail}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.email ? "border-danger" : ""
                              )}
                              placeholder="Admin email..."
                              name="email"
                              value={schoolData?.email}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "email",
                                  event.target.value.trimStart()
                                );
                              }}
                              ref={emailRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                            ref={classRef}
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.selectClass}
                            </Form.Label>
                            <CustomSelectWhite
                              options={
                                classDetails.length
                                  ? classDetails.map((val: any) => {
                                      return {
                                        value: val._id,
                                        label: val.name,
                                        _id: val._id,
                                      };
                                    })
                                  : []
                              }
                              value={schoolData?.classDetails?.map(
                                (classDetail: any) => {
                                  return {
                                    value: classDetail.reference,
                                    label: classDetail.name,
                                  };
                                }
                              )}
                              onChange={(selectedOptions: any) => {
                                handleClassDetails(selectedOptions);
                              }}
                              border={
                                schoolValidation.classDetails ? "#e55451" : ""
                              }
                              isMulti={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                            ref={classRef}
                          >
                            <Form.Label className="fs-16 fw-500">
                              {SchoolString.selectedAcademicYear}
                            </Form.Label>
                            <div className="d-flex flex-wrap align-items-center gap-2">
                              {schoolData?.academicSession ? (
                                <>
                                  {schoolData?.academicSession.map(
                                    (item: any) => {
                                      return (
                                        <span className="bg-light-primary rounded-1 p-3 fw-500 text-black fs-14 me-1">
                                          {item.label}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                            ref={classRef}
                          >
                            <Form.Label className="fs-16 fw-500">
                              {SchoolString.selectAcademicYear}
                            </Form.Label>
                            <CustomSelectWhite
                              options={
                                academicDetails.filter(
                                  (item: any) =>
                                    !schoolData.academicSession.find(
                                      (val: any) => val.value == item.value
                                    )
                                ) || []
                              }
                              value={schoolData?.academicYear}
                              onChange={(selectedOptions: any) => {
                                handleAcademicDetails(selectedOptions);
                              }}
                              border={
                                schoolValidation.academicYear ? "#e55451" : ""
                              }
                              isMulti={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.address}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.address ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="Address..."
                              name="name"
                              value={schoolData?.address}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "address",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.city}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.city ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="City..."
                              name="name"
                              value={schoolData?.city}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "city",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.state}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.state ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="State..."
                              name="name"
                              value={schoolData?.state}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "state",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.postalCode}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.postalCode
                                  ? "border-danger"
                                  : ""
                              )}
                              type="text"
                              placeholder="Postal code..."
                              name="postalCode"
                              value={schoolData?.postalCode}
                              onChange={(event: any) => {
                                handlePhoneChange(
                                  "postalCode",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPress(event, "postalCode");
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fs-16 fw-500 required">
                              {SchoolString.country}
                            </Form.Label>
                            <Form.Control
                              className={clsx(
                                "form-control-custom bg-white",
                                schoolValidation.country ? "border-danger" : ""
                              )}
                              type="text"
                              placeholder="Country..."
                              name="country"
                              value={schoolData?.country}
                              onChange={(event: any) => {
                                handleBasicDetailsChange(
                                  "country",
                                  event.target.value.trimStart()
                                );
                              }}
                              onKeyPress={(event: any) => {
                                handleOnKeyPressLetter(event);
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="align-items-center g-3 d-flex justify-content-end">
            <Col xs="auto">
              <Button
                variant="danger"
                size="lg"
                className="btn-active-danger"
                onClick={() => navigate("/all-schools")}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <Button
                variant="primary"
                size="lg"
                className="w-fit-content"
                onClick={() => handleAddSchool()}
                // disabled={
                //   apiLoading ||
                //   !schoolValidation.every(
                //     (obj) =>
                //       obj.certificateName === false &&
                //       obj.certificateImage === false
                //   )
                // }
              >
                {!fetchLoader && (
                  <span className="indicator-label fs-16 fw-bolder">
                    Submit
                  </span>
                )}
                {fetchLoader && (
                  <span
                    className="indicator-progress fs-16 fw-bolder"
                    style={{ display: "block" }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
export default EditSchool;
